<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii">BITTERLY DIVIDED</a></h1><a id="page_iii">
<p class="subtitle"><span class="small">THE SOUTH’S INNER CIVIL WAR</span></p>
<p class="author">David Williams</p>
<p class="pub-image"><img src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?4b91ff39